import { RESIZE_WINDOW } from 'actions/types';

const resize = () => {
  const sm = window.innerWidth < 1024;
  const xs = window.innerWidth < 800;
  return {
    height: window.innerHeight,
    width: window.innerWidth,
    sm,
    xs
  };
};

export default function(state = null, action) {
  switch (action.type) {
    case RESIZE_WINDOW:
      const resized = resize();
      return { ...state, ...resized };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/app.js